import { FeatureConfigItem } from "../../model/FeatureConfigItem";
import { FeatureConfigItemRepository } from "../../repositories/Repository";

export class GetFeatureConfigItemUseCase {
  constructor(private featureConfigItemRepository: FeatureConfigItemRepository) { }

  async execute(): Promise<FeatureConfigItem[]> {
    return await this.featureConfigItemRepository.getFeatureConfigItem();
  }
}